<template>
  <card :card-title="$t('homepage.txt004')" title-image="policy">
    <template #ope>
      <i class="operation-icon el-icon-arrow-right" @click="toMore"></i>
    </template>
    <div class="policy-list">
      <div class="policy-item" v-for="item in list" :key="item.id" @click="handleView(item)" :title="item.essayTitle">
        <div class="policy-title">{{ item.essayTitle }}</div>
        <div class="policy-time">{{ item.updateTime | dateFormat }}</div>
      </div>
    </div>
  </card>
</template>

<script>
import Card from './Card'
import { queryNewsList } from '@/api/policy/policy'
export default {
  name: "PolicyExpress",
  components: {
    Card
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        currentPage: 1,
        pageSize: 3
      }
      queryNewsList('new', params).then(res => {
        const { records } = res.data.data
        this.list = records.slice(0, 4)
      })
    },
    handleView(val) {
      const { essayUrl } = val
      window.open(essayUrl)
    },
    toMore() {
      this.$router.push({
        path: '/policy/index'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.policy-item {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  line-height: 16px;
  padding: 5px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
    color: #C73122;
  }
  .policy-title {
    width: calc(100% - 150px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .policy-time {
    width: 150px;
    text-align: right;
  }
}
</style>
